var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHashnode(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 35,
    viewBox: "0 0 34 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.33634 11.5941C-0.778779 14.7242 -0.778779 19.7986 2.33634 22.9285L11.36 31.9958C14.4751 35.1256 19.5252 35.1256 22.64 31.9958L31.6639 22.9285C34.7787 19.7984 34.7787 14.7238 31.6639 11.5941L22.64 2.52698C19.5249 -0.602743 14.4747 -0.602743 11.36 2.52698L2.33634 11.5941ZM20.9479 21.2284C23.1284 19.0373 23.1284 15.4852 20.9479 13.2944C18.7675 11.1033 15.2324 11.1033 13.0522 13.2944C10.8715 15.4855 10.8715 19.0373 13.0522 21.2284C15.2327 23.4192 18.7672 23.4192 20.9479 21.2284Z",
    fill: "#2962FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHashnode);
export default __webpack_public_path__ + "static/media/hashnode.2d47b7345dab81fb7cbf839e05bd1686.svg";
export { ForwardRef as ReactComponent };